import React from 'react'
import './Modal.sass'

const Modal = (props) => {

	const handleClose = () => { 
		props.handleClose(false)
	}

	return (
		<div className={`no__modal ${props.type}`}>
			<div className="no__modal-content">
				<strong className="no__close" onClick={handleClose}>&times;</strong>
				{props.children}
			</div>
		</div>
	)
}

export default Modal